import cn from './cn.js';
import Skeleton from './Skeleton.js';
import Badge from './Badge.js';

const iconTones = {
  brand: 'bg-indigo-50 text-indigo-600',
  success: 'bg-emerald-50 text-emerald-600',
  warning: 'bg-amber-50 text-amber-600',
  danger: 'bg-red-50 text-red-600',
  info: 'bg-sky-50 text-sky-600',
  purple: 'bg-purple-50 text-purple-600',
  neutral: 'bg-gray-100 text-gray-600',
};

/**
 * StatCard: a KPI tile. `value` can be a node; `loading` renders a skeleton.
 */
export default function StatCard({ label, value, hint, icon: Icon, tone = 'brand', badge, badgeTone = 'brand', loading = false, className, children, footer }) {
  return (
    <div className={cn('rounded-2xl bg-white p-5 ring-1 ring-gray-200 shadow-card', className)}>
      <div className="flex items-start justify-between gap-3">
        <p className="truncate text-sm font-medium text-gray-500">{label}</p>
        <div className="flex shrink-0 items-center gap-2">
          {badge && (
            <Badge tone={badgeTone} size="sm">
              {badge}
            </Badge>
          )}
          {Icon && (
            <span className={cn('inline-flex h-8 w-8 items-center justify-center rounded-lg', iconTones[tone] || iconTones.brand)}>
              <Icon className="h-4 w-4" aria-hidden="true" />
            </span>
          )}
        </div>
      </div>
      <div className="mt-3 text-3xl font-semibold tracking-tight text-gray-900 tabular-nums">
        {loading ? <Skeleton className="h-8 w-20" /> : value}
      </div>
      {hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
      {children}
      {footer && <div className="mt-4 border-t border-gray-100 pt-3 text-sm">{footer}</div>}
    </div>
  );
}
